import { EmployeeSearchResult } from '@dap/memberadmin/types';

/**
 * A cached result set at or above this size may have been truncated by the search API, so it
 * isn't narrowed for longer queries. The IAM spec documents no limit for `/v2/employees/search`;
 * lower this to the API's cap if it turns out to have one.
 */
export const MAX_REUSABLE_RESULTS = Infinity;

/**
 * The longest already-searched query that `needle` starts with. The API matches on
 * "containing query", so its results are a superset of the results for `needle`.
 */
export function findReusablePrefix(queries: Iterable<string>, needle: string): string | undefined {
  let best: string | undefined;
  for (const query of queries) {
    if (needle.startsWith(query) && (best === undefined || query.length > best.length)) {
      best = query;
    }
  }
  return best;
}

/** Mirrors the search API: name, email, phone number or userId containing the needle */
export function narrowEmployeeResults(
  results: EmployeeSearchResult[],
  needle: string
): EmployeeSearchResult[] {
  const lowerNeedle = needle.toLowerCase();
  return results.filter((employee) =>
    [employee.name, employee.email, employee.phoneNumber, employee.userId].some((field) =>
      field?.toLowerCase().includes(lowerNeedle)
    )
  );
}
